import { render, staticRenderFns } from "./SafeUser.vue?vue&type=template&id=e5e8247c&scoped=true"
import script from "./SafeUser.vue?vue&type=script&lang=js"
export * from "./SafeUser.vue?vue&type=script&lang=js"
import style0 from "./SafeUser.vue?vue&type=style&index=0&id=e5e8247c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e8247c",
  null
  
)

export default component.exports